import * as Sentry from '@sentry/react';

/**
 * Send client-side errors that bypass the axios response interceptor in
 * `ApiContext` — Azure Blob SDK and SignalR calls — to Sentry. Without this
 * they only reach the console and never surface for triage.
 *
 * `kind` groups events by source (`blob`, `signalr`); `operation` names the
 * specific call site so issues stay distinct in Sentry.
 */
export function captureClientError(error: unknown, kind: string, operation: string): void {
  Sentry.captureException(error, {
    tags: { kind, operation },
  });
}
